import axios from './base'

const base = `/stay/base`
const scenicBase = `/stay/scenic`

// ================= 旅居基地管理（后端 StayBaseService，tb_stay_base，/stay/base*） =================
// 产品规则：旅居为咨询制，无价格/房态/预订；基地下可再挂小区与房型
// 省市区存行政区划编码（与活动同口径），列表展示名称由前端走公共区域接口换取

// 基地列表（分页；keyword 基地名称/副标语、status 1展示 0下架；sort 升序 → id 升序）
export function getStayBaseList(params = {}) {
  return axios.request({
    url: `${base}`,
    method: "get",
    params,
  })
}

// 基地详情
export function getStayBaseDetail(id, params = {}) {
  return axios.request({
    url: `${base}/${id}`,
    method: "get",
    params,
  })
}

// 新增基地（features [{title,desc}]；cover 必填；consult_phone 留空走全局客服）
export function createStayBase(data = {}) {
  return axios.request({
    url: `${base}`,
    method: "post",
    data,
  })
}

// 编辑基地
export function updateStayBase(id, data = {}) {
  return axios.request({
    url: `${base}/${id}`,
    method: "put",
    data,
  })
}

// 删除基地（软删；基地下小区与房型需先行处理）
export function deleteStayBase(id, data = {}) {
  return axios.request({
    url: `${base}/${id}`,
    method: "delete",
    data,
  })
}

// 展示 / 下架（data: { status: 1 }）
export function setStayBaseStatus(id, data = {}) {
  return axios.request({
    url: `${base}/${id}/status`,
    method: "put",
    data,
  })
}

// 排序（data: { sort: 10 }；列表页排序输入框内联改）
export function setStayBaseSort(id, data = {}) {
  return axios.request({
    url: `${base}/${id}/sort`,
    method: "put",
    data,
  })
}

// 基地下拉（景区、小区表单「所属基地」用；返回 [{ id, name, status }]，含已下架基地，前端自行标注）
// 表单选项 = 该列表 + 前端自加的「公共景区（不挂基地）」项（值 0）
export function getStayBaseOptions(params = {}) {
  return axios.request({
    url: `${base}/options`,
    method: "get",
    params,
  })
}

// ================= 周边景区管理（后端 ScenicService，tb_scenic，/stay/scenic*） =================
// 景区搭在旅居基地下（base_id，0 = 公共景区不挂基地）；旅居详情页「周边景区」与景区列表页读取此数据
// 等级 level 取字典 scenic_level 的 value（text 风格：value 即 5A/4A，空串=不展示等级徽章）
// 类型 scenery_type 为运营自由输入文本；feature 为字符串数组（最多 6 条）
// 省市区存行政区划编码（与活动/基地同口径），列表展示名称由前端走公共区域接口换取

// 景区列表（分页；keyword 景区名称/副标语、base_id 所属基地（传 0 只看公共景区）、status 1展示 0下架；sort 升序 → id 升序）
export function getScenicList(params = {}) {
  return axios.request({
    url: `${scenicBase}`,
    method: "get",
    params,
  })
}

// 景区详情
export function getScenicDetail(id, params = {}) {
  return axios.request({
    url: `${scenicBase}/${id}`,
    method: "get",
    params,
  })
}

// 新增景区（cover 非必填；level 须为字典 scenic_level 的启用项）
export function createScenic(data = {}) {
  return axios.request({
    url: `${scenicBase}`,
    method: "post",
    data,
  })
}

// 编辑景区
export function updateScenic(id, data = {}) {
  return axios.request({
    url: `${scenicBase}/${id}`,
    method: "put",
    data,
  })
}

// 删除景区（软删）
export function deleteScenic(id, data = {}) {
  return axios.request({
    url: `${scenicBase}/${id}`,
    method: "delete",
    data,
  })
}

// 展示 / 下架（data: { status: 1 }）
export function setScenicStatus(id, data = {}) {
  return axios.request({
    url: `${scenicBase}/${id}/status`,
    method: "put",
    data,
  })
}

// 排序（data: { sort: 10 }；列表页排序输入框内联改）
export function setScenicSort(id, data = {}) {
  return axios.request({
    url: `${scenicBase}/${id}/sort`,
    method: "put",
    data,
  })
}

// ================= 旅居小区管理（后端 StayCommunityService，tb_stay_community，/stay/community*） =================
// 层级 基地→小区→房型；小区必挂基地（base_id）；配套设施走 Mongo、房型走 tb_stay_room，按小区独立维护
// 封面非必填（列表可显示「无图」占位）；intro / facility_intro 为富文本

// 小区列表（分页；keyword 小区名称/地址、base_id 所属基地、status 1展示 0下架；sort 升序 → id 升序）
export function getStayCommunityList(params = {}) {
  return axios.request({
    url: `/stay/community`,
    method: "get",
    params,
  })
}

// 新增小区（base_id 必填且须为真实基地；cover 可空）
export function createStayCommunity(data = {}) {
  return axios.request({
    url: `/stay/community`,
    method: "post",
    data,
  })
}

// 编辑小区
export function updateStayCommunity(id, data = {}) {
  return axios.request({
    url: `/stay/community/${id}`,
    method: "put",
    data,
  })
}

// 删除小区（软删；小区下房型与配套设施需先行处理）
export function deleteStayCommunity(id, data = {}) {
  return axios.request({
    url: `/stay/community/${id}`,
    method: "delete",
    data,
  })
}

// 展示 / 下架（data: { status: 1 }）
export function setStayCommunityStatus(id, data = {}) {
  return axios.request({
    url: `/stay/community/${id}/status`,
    method: "put",
    data,
  })
}

// 排序（data: { sort: 10 }；列表页排序输入框内联改）
export function setStayCommunitySort(id, data = {}) {
  return axios.request({
    url: `/stay/community/${id}/sort`,
    method: "put",
    data,
  })
}

// 保存配套导语（data: { facility_intro: '<p>...</p>' }；配套设施管理弹框内单独保存，不动其他字段）
export function saveStayCommunityFacilityIntro(id, data = {}) {
  return axios.request({
    url: `/stay/community/${id}/facility-intro`,
    method: "put",
    data,
  })
}

// 小区下拉（房型表单用；须传 base_id；返回 [{ id, name, status }]，含已下架小区，前端自行标注）
export function getStayCommunityOptions(params = {}) {
  return axios.request({
    url: `/stay/community/options`,
    method: "get",
    params,
  })
}

// ================= 房型管理（后端 StayRoomService，tb_stay_room） =================
// 房型挂在小区下（community_id 必填）；旅居咨询制无价格无库存
// facilities 为字符串数组（预设 + 自由输入，最多 8 个）；户型图可空

// 某小区的房型全量列表（弹框卡片展示，不分页；sort 升序 → id 升序）
export function getStayRoomList(communityId, params = {}) {
  return axios.request({
    url: `/stay/community/${communityId}/rooms`,
    method: "get",
    params,
  })
}

// 新增房型（community_id 必填且须为真实小区；image 可空）
export function createStayRoom(data = {}) {
  return axios.request({
    url: `/stay/room`,
    method: "post",
    data,
  })
}

// 编辑房型
export function updateStayRoom(id, data = {}) {
  return axios.request({
    url: `/stay/room/${id}`,
    method: "put",
    data,
  })
}

// 删除房型（软删）
export function deleteStayRoom(id, data = {}) {
  return axios.request({
    url: `/stay/room/${id}`,
    method: "delete",
    data,
  })
}

// ================= 配套设施管理（后端 StayFacilityService，Mongo mg_stay_facilities） =================
// scope 区分挂基地（1）还是小区（2），管理端全部挂小区（scope=2）；scope/scope_id 创建后不可改
// _id 为自增数字；软删

// 某挂载对象下的配套全量列表（params: { scope: 2, scope_id }；弹框卡片展示，不分页）
export function getStayFacilityList(params = {}) {
  return axios.request({
    url: `/stay/facility`,
    method: "get",
    params,
  })
}

// 新增配套（scope/scope_id 必填且挂载对象须存在；images 最多 3 张外链）
export function createStayFacility(data = {}) {
  return axios.request({
    url: `/stay/facility`,
    method: "post",
    data,
  })
}

// 编辑配套（scope/scope_id 不可改，后端忽略传入值）
export function updateStayFacility(id, data = {}) {
  return axios.request({
    url: `/stay/facility/${id}`,
    method: "put",
    data,
  })
}

// 删除配套（软删）
export function deleteStayFacility(id, data = {}) {
  return axios.request({
    url: `/stay/facility/${id}`,
    method: "delete",
    data,
  })
}
